<ng-container *ngIf="installedApp">

  <div class="column-wrapper">

    <div class="column overwrite">
      <icon-selector *ngIf="superadmin" [(model)]="installedApp"
                     [type]="'new'" key="iconOverride"></icon-selector>

      <div *ngIf="superadmin">{{installedApp.iconOverride}}</div>

      <mat-tab-group>
        <mat-tab *ngFor="let translation of installedApp.translations" [label]="translation.language">
          <mat-form-field>
            <input [(ngModel)]="translation.appTitle" matInput placeholder="Title">
          </mat-form-field>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="column disable">
      <smart-input (onChange)="saveInstalledApps()" [(model)]="installedApp" key="disabled"
                   translationPrefix="packages.installedApps"></smart-input>

      <ng-container *ngIf="installedApp.translations.length > 1">
        <p>{{'packages.installedApps.languageDisable'| translate}}</p>
        <mat-checkbox (change)="translation.hidden = !$event.checked"
                      *ngFor="let translation of installedApp.translations"
                      [checked]="!translation.hidden">{{translation.language}}
        </mat-checkbox>
      </ng-container>

      <ng-container>
        <p>{{'packages.installedApps.displayDisable'| translate}}</p>
        <mat-checkbox [(ngModel)]="installedApp.screenDisabled">Screen</mat-checkbox>
        <mat-checkbox [(ngModel)]="installedApp.mobileDisabled">Mobile</mat-checkbox>
      </ng-container>
    </div>

    <div class="column timing">
      <h4>{{'packages.installedApps.interval' | translate}}</h4>
      <smart-input [(model)]="installedApp" format="dd-mm" key="from"></smart-input>
      <smart-input [(model)]="installedApp" format="dd-mm" key="to"></smart-input>
      <button (click)="cancelTiming()" *ngIf="installedApp.from || installedApp.to" color="primary" mat-raised-button>
        <mat-icon>delete</mat-icon>
        {{'packages.installedApps.clearInterval' | translate}}
      </button>
    </div>

  </div>

  <ng-container *ngIf="superadmin">
    <div>
      <span><mat-checkbox [(ngModel)]="installedApp.isSecured">Secured app</mat-checkbox></span>
      <span><mat-checkbox [(ngModel)]="installedApp.widgetOnly">Widget only</mat-checkbox></span>
      <span><mat-checkbox [(ngModel)]="installedApp.skipWhenOnlyChild">Skip when only child</mat-checkbox></span>
    </div>
    <div class="spacer"></div>
    <mat-expansion-panel class="code-area">
      <mat-expansion-panel-header>
        <mat-panel-title>menuEntryDetail</mat-panel-title>
        <mat-panel-description>Expand to edit</mat-panel-description>
      </mat-expansion-panel-header>
      <code-area [options]="codeEditorOptions" [parent]="installedApp" [value]="installedApp.detail" key="detail" type="json"></code-area>
    </mat-expansion-panel>
  </ng-container>

  <div class="button-container">
    <button (click)="saveInstalledApps()" class="ibexfusion-raised-button" mat-button>
      <mat-icon>save</mat-icon>{{'packages.installedApps.save' | translate}}</button>
    <br/>
    <button (click)="resetHighscore.emit()" *ngIf="hasHighScoreReset" class="ibexfusion-raised-button" mat-button>
      <mat-icon>settings_backup_restore</mat-icon>{{'packages.installedApps.resetHighscore' | translate}}
    </button>
    <br/>
    <ng-container *ngIf="superadmin">
      <button (click)="removeInstalledApp()" class="ibexfusion-raised-button" mat-button>
        <mat-icon>delete</mat-icon>{{'packages.installedApps.remove' | translate}}
      </button>
    </ng-container>
  </div>

</ng-container>
